import script from "./gsrcm0103.vue?vue&type=script&setup=true&lang=js"
export * from "./gsrcm0103.vue?vue&type=script&setup=true&lang=js"

import "./gsrcm0103.vue?vue&type=style&index=0&id=54628882&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54628882"]])

export default __exports__